import { render, staticRenderFns } from "./SaveDeniedModal.vue?vue&type=template&id=f982d1fe&scoped=true&"
import script from "./SaveDeniedModal.vue?vue&type=script&lang=js&"
export * from "./SaveDeniedModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveDeniedModal.vue?vue&type=style&index=0&id=f982d1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f982d1fe",
  null
  
)

export default component.exports